import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ExcoVideoWrapperAsync } from 'site-modules/shared/components/exco-video/exco-video-wrapper-async';

const MODEL_NAME_EXCO_VIDEO_PLAYER = 'GV70';

export function ExcoVideoCorePage({
  showTestText = false,
  headingCopy = 'Learn More About the',
  id = null,
  scrollMarginTop = '64px',
}) {
  return (
    <Fragment>
      <div id={id} className="heading-4 mb-0_5 pos-r" style={{ scrollMarginTop }}>
        {headingCopy} {MODEL_NAME_EXCO_VIDEO_PLAYER}
      </div>
      <div className="overflow-hidden mx-auto" style={{ maxWidth: '540px' }}>
        <span className="text-gray-darker small float-end mb-0_25">Sponsored</span>
      </div>
      <div
        style={{ aspectRatio: '16 / 9', maxWidth: '540px' }}
        className="w-100 rounded-12 overflow-hidden mx-auto mb-2"
      >
        <ExcoVideoWrapperAsync showTestText={showTestText} />
      </div>
    </Fragment>
  );
}

ExcoVideoCorePage.propTypes = {
  showTestText: PropTypes.bool,
  headingCopy: PropTypes.string,
  id: PropTypes.string,
  scrollMarginTop: PropTypes.string,
};
